import React from "react"
import { colors, Text } from "@carrotfertility/carotene"
import PlanInformationRow, { InsurancePlanInformationRowData } from "./InsurancePlanInformationRow"
import styled from "styled-components"
import { useIntl } from "react-intl"

const StyledTable = styled.table`
  border-spacing: 32px;
  border-collapse: collapse;
`

const StyledHeaderRow = styled.tr`
  border-bottom: 2px solid #f4f2ef;
`

const StyledTableHeader = styled.th`
  height: 23px;
  padding-right: 32px;
  text-align: left;
`

const HeaderText = styled(Text)`
  color: ${colors.base.black60} !important;
`

type PlanInformationTableProps = {
  planData: InsurancePlanInformationRowData[]
  hasPartner: boolean
  insuranceExpired: boolean
}
const InsurancePlanInformationTable = (props: PlanInformationTableProps): JSX.Element => {
  const { planData, hasPartner, insuranceExpired } = props
  const intl = useIntl()

  return (
    <StyledTable>
      <thead>
        <StyledHeaderRow>
          <StyledTableHeader />
          <StyledTableHeader>
            <HeaderText weight="bolder" size="small">
              {hasPartner
                ? intl.formatMessage({ defaultMessage: "You" })
                : intl.formatMessage({ defaultMessage: "Answers" })}
            </HeaderText>
          </StyledTableHeader>
          {hasPartner && (
            <StyledTableHeader>
              <HeaderText weight="bolder" size="small">
                {intl.formatMessage({ defaultMessage: "Your Partner" })}
              </HeaderText>
            </StyledTableHeader>
          )}
        </StyledHeaderRow>
      </thead>
      <tbody>
        {planData.map((row, index) => (
          <PlanInformationRow key={index} {...{ hasPartner, insuranceExpired, ...row }} />
        ))}
      </tbody>
    </StyledTable>
  )
}

export default InsurancePlanInformationTable
